import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { UserPollsService } from "app/frontend/lib/polls/user-polls/user-polls.service";
import { PollInTeam, PollOccurrence } from "app/frontend/lib/polls/user-polls/user-polls.type";

@Component({
    selector: "poll-task-details-occurrence",
    templateUrl: "./poll-task-details-occurrence.component.html",
    styleUrls: ["./poll-task-details-occurrence.component.scss"],
    imports: [
        CommonModule,
        MatTooltipModule,
        TranslateModule,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class PollTaskDetailsOccurenceComponent {

    @Input() occurrence: PollOccurrence
    @Input() pollFrequency: string
    @Input() isSelected: boolean;

    @Input() searchTerm: string;

    @Output() onSelectOccurence = new EventEmitter<PollOccurrence>();
    
    constructor(
        private userPollsService: UserPollsService
    ){}

    select(occurrence: PollOccurrence){
        this.onSelectOccurence.emit(occurrence);
        this.isSelected = true;
    }

    protected getOccurrenceDate(occurrence: PollOccurrence, type: string){
        return this.userPollsService.getOccurrenceDate(occurrence, type);
    }

    protected getOccurrenceDateDetail(occurrence: PollOccurrence){
        return this.userPollsService.getOccurrenceDateDetail(occurrence);
    }

    protected getLiveOccurrenceDateDetail(occurrence: PollOccurrence){
        return this.userPollsService.getLiveOccurrenceDateDetail(occurrence);
    }

    protected getOccurrenceParticipation(teams: PollInTeam[]){
        return this.userPollsService.getOccurrenceParticipation(teams);
    }

}